import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import ErrorBoundary from "./components/ErrorBoundary";
import DPLJade from "./components/DPLJade";
import LandingPage   from "./marketing/pages/LandingPage";
import PrivacyPolicy from "./marketing/pages/PrivacyPolicy";
import TermsOfUse    from "./marketing/pages/TermsOfUse";
import Disclaimer    from "./marketing/pages/Disclaimer";
import RefundPolicy  from "./marketing/pages/RefundPolicy";
import UserGuide     from "./marketing/pages/UserGuide";
import AccountPage   from "./marketing/pages/AccountPage";
import NotFound      from "./marketing/pages/NotFound";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Routes>
          <Route path="/"           element={<LandingPage />} />
          <Route path="/app"        element={<DPLJade />} />
          <Route path="/guide"      element={<UserGuide />} />
          <Route path="/privacy"    element={<PrivacyPolicy />} />
          <Route path="/terms"      element={<TermsOfUse />} />
          <Route path="/disclaimer" element={<Disclaimer />} />
          <Route path="/refunds"    element={<RefundPolicy />} />
          <Route path="/account"    element={<AccountPage />} />
          {/* fallback */}
          <Route path="*"           element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </ErrorBoundary>
  </React.StrictMode>
);
